import type { ComponentType } from 'react'
import Buildings from './Buildings'
import Calendar from './Calendar'
import CrossedTools from './CrossedTools'
import Dumbbell from './Dumbbell'
import Enterprise from './Enterprise'
import Flag from './Flag'
import Heart from './Heart'
import Lightbulb from './Lightbulb'
import Medal from './Medal'
import Mountains from './Mountains'
import SpeechBubbles from './SpeechBubbles'
import ToolSet from './ToolSet'

export const animatedIconRegistry: Partial<Record<string, ComponentType>> = {
  'buildings': Buildings,
  'calendar': Calendar,
  'crossed-tools': CrossedTools,
  'dumbbell': Dumbbell,
  'enterprise': Enterprise,
  'flag': Flag,
  'heart': Heart,
  'lightbulb': Lightbulb,
  'medal': Medal,
  'mountains': Mountains,
  'speech-bubbles': SpeechBubbles,
  'tool-set': ToolSet,
}

export function getAnimatedIcon(name: string | null | undefined): ComponentType | undefined {
  if (!name) return undefined
  return animatedIconRegistry[name]
}
